import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddEditActionsModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddEditActionsModal = () => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  const handleInputChange = (e) => {
    const { value } = e.target
    changeValue(value, 'name')
  }

  return (
    <div className={st.fieldSet}>
      <FormField>
        <FormLabel isRequired>Действие:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={'Действие'}
            name='name'
            value={modalValue?.name || ''}
            onChange={handleInputChange}
            maxLength={60}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(AddEditActionsModal)
